import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "tp-theme";

/**
 * Simple light/dark theme hook. Defaults to LIGHT.
 * Adds/removes `dark` class on <html> and persists choice in localStorage.
 */
export default function useTheme() {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "light";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === "dark" ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    try { window.localStorage.setItem(STORAGE_KEY, theme); } catch (_e) { /* ignore */ }
  }, [theme]);

  const setTheme = useCallback((t) => setThemeState(t === "dark" ? "dark" : "light"), []);
  const toggle = useCallback(() => setThemeState((t) => (t === "dark" ? "light" : "dark")), []);

  return { theme, setTheme, toggle, isDark: theme === "dark" };
}
